<template>
  <tool-advance-filter-content
    :contentInfo="contentInfo"
    :addButtonText="addButtonText"
    :chartProperties="chartProperties"
    :linePlotData="linePlotData"
    :chartData="chartGraphData"
    :selectedComponent="superSelectedComponent"
    :isNotShowGraph="isNotShowGraph"
    :updateButtonText="updateButtonText"
    :headers="headers"
    :rows="rows"
    :singleHeading="singleHeading"
    :isShowHint="isShowHint"
    :infoText="infoText"
    :infoError="infoError"
    :emptyChartMessage="emptyChartMessage"
    @addRow="addRow"
    @editableRowButtonClick="genericMethodClick"
    @setFocusOnRowElement="setFocusOnRowElement"
    :focusElementName="focusElementName"
    :gridButtonTemplate="gridButtonTemplate"
    :singleHeadingOptions="singleHeadingOptions"
    :singleHeadingButtonText="singleHeadingButtonText"
    :gridSplitId="gridSplitId"
    @GridSelectionChange="AddNewTypeRow"
    :rowTemplateButton="rowTemplateButton"
    @rowTemplateButtonClick="genericMethodClick"
    @OuterRowButtonClick="genericMethodClick"
    :rowOuterButton="rowOuterButton"
    @onChange="OnOptionChange"
    :emptyGridData="emptyGridData"
    @removeRow="removeRow"
    :clientId="clientId"
    @onChangeChartTab="onChangeSuperChartTab"
  ></tool-advance-filter-content>
</template>
<script>
import { ToolAdvanceFilterContent } from "../../component/tool";
import { AdvanceSuperFilter, FeeTypeIndex, OptionIndex } from "../../helpers/constant";

import {
  EngagementToolCommon,
  SuperannuationAdvanceFilterContent,
} from "../../mixin";
import {
  GET_SELECTED_SUPERANNUATION_INFORMATION,
  GET_SUPERANNUATION_INFORMATION,
} from "../../helpers/vuex-constants";
import { mapGetters } from "vuex";
import _ from "lodash";
export default {
  props: {
    baselineData: {
      type: Object,
    },
    clientId: {
      type: Number,
    },
    clientName: {
      type: String,
    },
  },
  components: { ToolAdvanceFilterContent },
  mixins: [EngagementToolCommon, SuperannuationAdvanceFilterContent],
  computed: {
    ...mapGetters("superannuation", {
      selectedSuperannuationData: GET_SELECTED_SUPERANNUATION_INFORMATION,
      getSuperannuationInformation: GET_SUPERANNUATION_INFORMATION,
    }),
    gridButtonTemplate() {
      let difference = true;
      let Superannuations = this.getSuperannuationInformation.filter(
        (sr) =>
          sr.superFundGuid == this.selectedSuperannuationData.superFundGuid
      );
      let ExistingData = Superannuations[0].superAddtionalDetails
        .filter(
          (sr) =>
            sr.typeId == AdvanceSuperFilter.FeeAccumulation && sr.clientID == this.clientId
        )
        .map(function (t) {
          let p = {};
          p.amount1 = t.amount1;
          p.amount2 = t.amount2;
          p.amount3 = t.amount3;
          p.startDate = t.startDate;
          p.endDate = t.endDate;
          p.startDateType = t.startDateType;
          p.endDateType = t.endDateType;
          p.clientID = t.clientID;
          p.index = t.index;
          p.frequency = t.frequency;
          p.option1 = t.option1;
          p.superTypeId = t.superTypeId;
          return p;
        });

      let CurrentDataObject = [];
      for (let i = 0; i < this.rows.length; i++) {
        if (ExistingData.length > 0)
          CurrentDataObject.push({
            amount1: this.rows[i].amount1.value,
            amount2: this.rows[i].amount2.value,
            amount3: this.rows[i].amount3.value,
            startDate: this.rows[i].startDate.value,
            endDate: this.rows[i].endDate.value,
            startDateType: this.rows[i].startDateType.value,
            endDateType: this.rows[i].endDateType.value,
            superTypeId: this.rows[i].superTypeId.value,
            index: this.rows[i].index.value,
            frequency: this.rows[i].frequency.value,
            clientID:
              this.rows[i].clientID == undefined
                ? this.clientId
                : this.rows[i].clientID.value,
            option1: this.rows[i].option1.value,
          });
        else {
          if (!this.validatebyrow(this.rows[i], this.rows[i].subTypeId.value)) {
            difference = false;
            break;
          }
        }
      }
      if (ExistingData.length > 0) {
        difference = _.isEqual(ExistingData, CurrentDataObject);
      }
      this.enableResetButton(difference, "UpdateGraph");
      this.enableResetButton(difference, "reset");

      return this.gridButtonTemplatedata;
    },
    legendItems() {
      return ["", "Additional Drawdowns"];
    },
    baselineFilterObject() {
      return Object.assign({}, this.baselineData);
    },
  },

  mounted() {
    this.getinsertEmptyRows(this.rows);
    this.contentInfo = {
      chartTabContent: [],//this.getSuperTimeSeriesChartTab(),
      heading: ` ${this.clientName} Accumulation Fee`,
      subHeading:
        "You can enter in different return at different time periods.",
      infoAlert: {
        title: "Important note",
        variation: "informational",
        text: "You can enter in different return at different time periods.",
      },
    };
  },
  data() {
    return {
      contentInfo: {},
      selectedOption: AdvanceSuperFilter.FeeAccumulation,
      emptyGridData: {
        title: "Click to add Additional Fees",
        message: "",
        imagepath: "../../assets/icons/dollar.svg",
        buttonVisible: true,
        list: [],
      },
      rowOuterButton: [],
      focusElementName: "",
      rowTemplateButton: [
        {
          icon: "plus",
          size: "medium",
          variation: "flat",
          text: "Add new",
          callBackMethod: "AddNewTypeRow",
          isdisabled: false,
          key: "AddNewTypeRow",
        },
      ],
      gridButtonTemplatedata: [
        {
          icon: "eye",
          size: "medium",
          variation: "primary",
          text: "Preview Graph",
          callBackMethod: "UpdateGraph",
          isdisabled: false,
          key: "UpdateGraph",
        },
        {
          size: "medium",
          variation: "secondary",
          isdisabled: true,
          text: "Reset",
          callBackMethod: "reset",
          key: "reset",
        },
      ],
      timeSeriesChartData: [],
      emptyChartMessage: {
        message: "Add Drawdown details to create a chart.",
        btnTxt: "",
      },

      updateButtonText: "Update Graph",
      addButtonText: "Add new",
      isShowHint: true,
      infoText: ["Hit 'Tab' to move to the next cell and add a new row"],
      singleHeadingOptions: [
        {
          key: 1,
          value: "Regular",
          fields: [
            "superTypeId",
            "option1",
            "amount1",
            "amount2",
            "amount3",
            "index",
            "frequency",
            "startDate",
            "endDate",
          ],
          overlapvalidations: true,
        },
        {
          key: 2,
          value: "Lump Sum",
          fields: [
            "superTypeId",
            "option1",
            "amount1",
            "amount2",
            "amount3",
            "startDate",
          ],
          overlapvalidations: false,
          showDateLabel: true,
        },
      ],
      singleHeadingButtonText: "",
      gridSplitId: "subTypeId",

      infoError: false,
      singleHeading: "",
      headers: [
        {
          type: "Dropdown",
          label: "Type",
          cols: 1,
          key: "superTypeId",
          options: this.typeOptions(),
          defaultValue: "1",
          validation: true,
        },
        {
          type: "Dropdown",
          label: "Option",
          cols: 1,
          key: "option1",
          options: this.OptionOptions(),
          defaultValue: 1,
          validation: true,
        },
        {
          type: "FormatInput",
          label: "%",
          cols: 1,
          key: "amount1",
          isAllowOnlyNumber: true,
          appendText: "",
          currencyFormat: "",
          max: 100,
          length: 3,
          validation: true,
          style: {
            overflow: "visible",
          },
        },
        {
          type: "FormatInput",
          label: "$",
          cols: 1,
          key: "amount2",
          isAllowOnlyNumber: true,
          appendText: "",
          currencyFormat: "$,",
          max: 999999999,
          length: 9,
          validation: true,
          style: {
            overflow: "visible",
          },
        },
        {
          type: "FormatInput",
          label: "$ cap",
          cols: 1,
          key: "amount3",
          isAllowOnlyNumber: true,
          appendText: "",
          currencyFormat: "$,",
          max: 999999999,
          length: 9,
          validation: true,
          style: {
            overflow: "visible",
          },
        },
        {
          type: "Dropdown",
          label: "Index",
          cols: 1,
          key: "index",
          options: this.indexOptions(),
          defaultValue: "AWOTE",
          validation: true,
        },
        {
          type: "Dropdown",
          label: "Frequency",
          cols: 1,
          key: "frequency",
          options: this.frequencyOptionForSuperFee(),
          defaultValue: "Weekly",
          validation: true,
          style: {
            width: "100px",
            overflow: "visible",
          },
        },
        {
          type: "MonthPickerSelect",
          displayTop: true,
          typing: true,
          label: "Start",
          text: "Date",
          cols: 2,
          key: "startDate",
          listdata: this.startOptionsNew(),
          sort: "years",
          minYear: 2022,
          yearTerm: 50,
          style: {
            width: "130px",
            overflow: "visible",
          },
          validation: true,
        },
        {
          type: "MonthPickerSelect",
          displayTop: true,
          typing: true,
          label: "End",
          cols: 2,
          key: "endDate",
          listdata: this.startOptionsNew(),
          sort: "years",
          minYear: 2022,
          yearTerm: 50,
          style: {
            width: "130px",
            overflow: "visible",
          },
          validation: true,
        },
        {
          type: "Icon",
          label: "",
          iconText: "Validation",
          icon: "check",
          cols: 1,
          isShowDelete: true,
          isShowSuccess: false,
          class: "cf-Icon-Align",
          style: {
            width: "30px",
          },
          data: [
            {
              label: "",
              iconText: "Delete",
              icon: "trash",
              type: "icon",
              path: "",
              action: "delete",
            },
          ],
        },
      ],
      rows: this.fillGrid(),
    };
  },
  async created() {},
  beforeMount() {
    this.baselineFilterObject.superAddtionalDetails.forEach(element => {
      if (element.typeId.value == AdvanceSuperFilter.FeeAccumulation) {
        let data = { key: "option1", row: element };
        this.OnOptionChange(data);
      }
    });
    this.superValidations(
      this.baselineFilterObject.superAddtionalDetails,
      AdvanceSuperFilter.FeeAccumulation,
      this.clientId
    );
  },
  beforeDestroy() {
    this.fillSuperannuationModel(AdvanceSuperFilter.FeeAccumulation, this.clientId);
    this.superValidations(
      this.baselineFilterObject.superAddtionalDetails,
      AdvanceSuperFilter.FeeAccumulation,
      this.clientId
    );
  },
  methods: {
    OnOptionChange(data) {
      if (data.key == "option1") {
        switch (data.row.option1.value-0) {
          case OptionIndex.PersentOnly:
            data.row.amount1.disable=false;
            data.row.amount2.disable=true;
            data.row.amount3.disable=true;
            if(data.row.subTypeId.value == 1)
            {
              data.row.index.disable=true;
              data.row.frequency.disable=true;
            }
            break;
          case OptionIndex.AmountOnly:
            data.row.amount1.disable=true;
            data.row.amount2.disable=false;
            data.row.amount3.disable=true;
            if(data.row.subTypeId.value == 1)
            {
              data.row.index.disable=false;
              data.row.frequency.disable=false;
            }
            break;
          case OptionIndex.PersentWithAmountCap:
            data.row.amount1.disable=false;
            data.row.amount2.disable=true;
            data.row.amount3.disable=false;
            if(data.row.subTypeId.value == 1)
            {
              data.row.index.disable=false;
              data.row.frequency.disable=true;
            }
            break;
        }
      }
      if (data.key == "superTypeId")
      {
        // Fee Option is dependent on the Type of Fee Selected
        switch(data.row.superTypeId.value-0){
          case FeeTypeIndex.Platform:
            data.row.option1.disable=false;
            break;
          case FeeTypeIndex.Admin:
            data.row.option1.disable=false;
            break;
          case FeeTypeIndex.Insurance:
            data.row.option1.disable=true;
            data.row.option1.value=OptionIndex.AmountOnly;
            data.row.amount1.disable=true;
            data.row.amount2.disable=false;
            data.row.amount3.disable=true;
            break;
          case FeeTypeIndex.Other:
            data.row.option1.disable=true;
            data.row.option1.value=OptionIndex.AmountOnly;
            data.row.amount1.disable=true;
            data.row.amount2.disable=false;
            data.row.amount3.disable=true;
            break;
        }
      }
    },
    async UpdateGraph() {
      await this.updateAllAdvanceSuperGraph(
        AdvanceSuperFilter.FeeAccumulation,
        this.clientId
      );
    },
    getUserInputData(rows) {
      let addtionalData = [];
      for (let i = 0; i < rows.length; i++) {
        if (!this.validatebyrow(rows[i], rows[i].subTypeId.value)) {
          addtionalData.push({
            amount2: {
              value: rows[i].amount2.value,
              IsError: false,
              ErrorText: [],
              disable: rows[i].amount2.disable,
            },
            amount3: {
              value: rows[i].amount3.value,
              IsError: false,
              ErrorText: [],
              disable: rows[i].amount3.disable,
            },
            amount1: {
              value: rows[i].amount1.value,
              IsError: false,
              ErrorText: [],
              disable: rows[i].amount1.disable,
            },
            index: {
              value: rows[i].index.value,
              IsError: false,
              ErrorText: [],
              disable: rows[i].index.disable,
            },
            frequency: {
              value: rows[i].frequency.value,
              IsError: false,
              ErrorText: [],
              disable: rows[i].frequency.disable,
            },
            startDateType: {
              value:
                rows[i].startDate.value == undefined
                  ? 0
                  : rows[i].startDate.value.value == undefined
                  ? rows[i].startDateType.value
                  : rows[i].startDate.value.value,
              IsError: false,
              ErrorText: [],
              disable: rows[i].startDateType.disable,
            },
            startDate: {
              value:
                rows[i].startDate.value == undefined
                  ? 0
                  : rows[i].startDate.value.meta == undefined
                  ? rows[i].startDate.value
                  : rows[i].startDate.value.meta,
              IsError: false,
              ErrorText: [],
              disable: rows[i].startDate.disable,
            },
            endDateType: {
              value:
                rows[i].endDate.value == undefined
                  ? 0
                  : rows[i].endDate.value.value == undefined
                  ? rows[i].endDateType.value
                  : rows[i].endDate.value.value,
              IsError: false,
              ErrorText: [],
              disable: rows[i].endDateType.disable,
            },
            endDate: {
              value:
                rows[i].endDate.value == undefined
                  ? ""
                  : rows[i].endDate.value.meta == undefined
                  ? rows[i].endDate.value
                  : rows[i].endDate.value.meta,
              IsError: false,
              ErrorText: [],
              disable: rows[i].endDate.disable,
            },
            option1: {
              value: rows[i].option1.value,
              IsError: false,
              ErrorText: [],
              disable: rows[i].option1.disable,
            },
            superTypeId: {
              value: rows[i].superTypeId.value,
              IsError: false,
              ErrorText: [],
              disable: rows[i].superTypeId.disable,
            },
            typeId: {
              value: AdvanceSuperFilter.FeeAccumulation,
              IsError: false,
              ErrorText: [],
            },
            subTypeId: {
              value: rows[i].subTypeId.value,
              IsError: false,
              ErrorText: [],
            },
            clientID: {
              value:
                rows[i].clientID.value == undefined
                  ? this.clientId
                  : rows[i].clientID.value,
              IsError: false,
              ErrorText: [],
            },
            newRow: false,
          });
        }
      }
      return addtionalData;
    },
    DeleteSubtype(data) {
      this.rows = this.rows.filter((x) => x.subTypeId.value != data);
    },

    fillGrid() {
      let gridRows = [];
      if (this.baselineData.superAddtionalDetails != null) {
        let data = this.baselineData.superAddtionalDetails.filter(
          (sr) =>
            sr.typeId.value == AdvanceSuperFilter.FeeAccumulation &&
            sr.clientID.value == this.clientId
        );
        if (data != null && data.length > 0) {
          gridRows = this.emptyGridRow(data);
        }
      }
      return gridRows;
    },

    setFocusOnRowElement() {
      this.focusElementName = this.headers[0].key + "0";
    },
    fillData(data, subTypeId = 0) {
      let IsDataundfined = data == undefined;
      let startDateType = IsDataundfined
        ? 0
        : data.startDateType.value == 0
        ? 6
        : data.startDateType.value;
      let endDateType = IsDataundfined
        ? 0
        : data.endDateType.value == 0
        ? 6
        : data.endDateType.value;
      if (subTypeId == 0 && !IsDataundfined) {
        subTypeId = data.subTypeId.value;
      }
      let emptyObject = {
        subTypeId: {
          value: IsDataundfined ? subTypeId : data.subTypeId.value,
          IsError: IsDataundfined ? false : data.subTypeId.IsError,
          ErrorText: IsDataundfined ? [] : data.subTypeId.ErrorText,
          disable: IsDataundfined ? false : data.subTypeId.disable,
        },
        index: {
          value: IsDataundfined ? 0 : data.index.value,
          IsError: IsDataundfined ? false : data.index.IsError,
          ErrorText: IsDataundfined ? [] : data.index.ErrorText,
          disable: IsDataundfined ? false : data.index.disable,
        },
        amount2: {
          value: IsDataundfined ? 0 : data.amount2.value,
          IsError: IsDataundfined ? false : data.amount2.IsError,
          ErrorText: IsDataundfined ? [] : data.amount2.ErrorText,
          disable: IsDataundfined ? true : data.amount2.disable,
        },
        amount3: {
          value: IsDataundfined ? 0 : data.amount3.value,
          IsError: IsDataundfined ? false : data.amount3.IsError,
          ErrorText: IsDataundfined ? [] : data.amount3.ErrorText,
          disable: IsDataundfined ? true : data.amount3.disable,
        },
        amount1: {
          value: IsDataundfined ? 0 : data.amount1.value,
          IsError: IsDataundfined ? false : data.amount1.IsError,
          ErrorText: IsDataundfined ? [] : data.amount1.ErrorText,
          disable: IsDataundfined ? true : data.amount1.disable,
        },
        frequency: {
          value: IsDataundfined ? 0 : data.frequency.value,
          IsError: IsDataundfined ? false : data.frequency.IsError,
          ErrorText: IsDataundfined ? [] : data.frequency.ErrorText,
          disable: IsDataundfined ? false : data.frequency.disable,
        },
        startDateType: {
          value: IsDataundfined ? 0 : data.startDateType.value,
          IsError: IsDataundfined ? false : data.startDateType.IsError,
          ErrorText: IsDataundfined ? [] : data.startDateType.ErrorText,
          disable: IsDataundfined ? false : data.startDateType.disable,
        },
        startDate: {
          value: IsDataundfined ? "" : data.startDate.value,
          IsError: IsDataundfined ? false : data.startDate.IsError,
          ErrorText: IsDataundfined ? [] : data.startDate.ErrorText,
          text: IsDataundfined
            ? ""
            : this.startOptionsNew().filter((x) => x.value == startDateType)[0]
                .text,
        },
        superTypeId: {
          value: IsDataundfined ? 0 : data.superTypeId.value,
          IsError: IsDataundfined ? false : data.superTypeId.IsError,
          ErrorText: IsDataundfined ? [] : data.superTypeId.ErrorText,
          disable: IsDataundfined ? false : data.superTypeId.disable,
        },
        typeId: {
          value: IsDataundfined ? AdvanceSuperFilter.FeeAccumulation : data.typeId.value,
          IsError: IsDataundfined ? false : data.typeId.IsError,
          ErrorText: IsDataundfined ? [] : data.typeId.ErrorText,
          disable: IsDataundfined ? false : data.typeId.disable,
        },
        endDateType: {
          value: IsDataundfined ? 0 : data.endDateType.value,
          IsError: IsDataundfined ? false : data.endDateType.IsError,
          ErrorText: IsDataundfined ? [] : data.endDateType.ErrorText,
          disable: IsDataundfined ? false : data.endDateType.disable,
        },
        endDate: {
          value: IsDataundfined ? "" : data.endDate.value,
          IsError: IsDataundfined ? false : data.endDate.IsError,
          ErrorText: IsDataundfined ? [] : data.endDate.ErrorText,
          text:
            IsDataundfined || data.endDate.value == ""
              ? ""
              : this.startOptionsNew().filter((x) => x.value == endDateType)[0]
                  .text,
        },
        option1: {
          value: IsDataundfined ? 0 : data.option1.value,
          IsError: IsDataundfined ? false : data.option1.IsError,
          ErrorText: IsDataundfined ? [] : data.option1.ErrorText,
          disable: IsDataundfined ? false : data.option1.disable,
        },
        clientID: {
          value: IsDataundfined ? this.clientId : data.clientID.value,
        },
        newRow: IsDataundfined ? true : false,
      };
      return emptyObject;
    },
    emptyGridRow(data) {
      if (data == undefined) {
        return this.fillData();
      } else {
        let gridData = [];
        for (let i = 0; i < data.length; i++) {
          gridData.push(this.fillData(data[i]));
        }
        return gridData;
      }
    },
  },
};
</script>
<style lang="scss" module></style>
